<template>
  <!-- variant="pill" = 浅色收口条 + 胶囊按钮，全站默认（2026-09-16 起）。
       传 variant="" 可退回旧的「右上角四个文字按钮」样式。 -->
  <div class="BottomNavigation" :class="{ 'is-pill': variant === 'pill' }">
    <div class="BottomNavigation-tabs">
      <template v-for="(item, index) in tabs">
        <div
          :key="index"
          class="box"
          :class="{ 'is-active': item.in }"
          @click="tabsClick(item)"
        >
          <div class="box-item">{{ item.title }}</div>
          <div class="box-item1" v-show="item.in"></div>
        </div>
      </template>
    </div>
    <div class="box-text" >
      <a :href="icpUrl" target="_blank" style="color:#000;text-decoration: none; " class="link">{{
        icpText
      }}</a>
      <span class="boxxxx">版权所有&#169;{{SettingList.copyright}}</span>
      <span class="boxxxx">联系我们：{{SettingList.company_tel}}</span>
    </div>
  </div>
</template>

<script>
import { corporateSettingApi } from "@/api/toolApi";
export default {
  name: "BottomNavigation",
  props: {
    /*
     * "pill" → 浅色收口条 + 胶囊按钮。
     * 📌 2026-09-16 第五轮：默认值由 "" 改成 "pill"，**全站四个按钮（首页/产业服务/
     *    会员福利/个人中心）统一成同一套外观**。
     *    原因：之前只有个人中心及其二级页显式传了 variant="pill"，
     *    其余 14 个页面走默认分支，于是「在个人中心页是新样式、切到别的页又变回老样式」。
     *    pill 分支是在原样式基础上叠加的（宽高/定位仍来自 .BottomNavigation 基础规则），
     *    所以翻默认值不会影响任何页面的布局，只是页脚外观一致了。
     *    想回到老样式：把这里改成 default: ""，或在页面上显式传 variant=""。
     */
    variant: {
      type: String,
      default: "pill",
    },
  },
  data() {
    return {
      SettingList: [],
      tabs: [
        {
          title: "首页",
          in: false,
          route: "/",
          rou: [
            "/",
            "/recharge",
            "/rechargeS",
            "/SearchDetails",
            "/chatGpt",
            "/advancedSearch",
          ],
        },
        {
          title: "产业服务",
          in: false,
          route: "/industrialService",
          // 2026-09-16：补上 /zhaoshang（产业招商）。
          // 原来这个数组只有 /industrialService，导致从产业服务点进产业招商后，
          // 底部四个按钮**一个都不高亮**，看着像导航坏了。
          rou: ["/industrialService", "/zhaoshang"],
        },
        {
          title: "会员福利",
          in: false,
          route: "/VIP",
          rou: ["/VIP"],
        },
        {
          title: "个人中心",
          in: false,
          route: "/personalCenter",
          rou: ["/personalCenter"],
        },
      ],
    };
  },
  computed: {
    /*
     * 备案号按访问域名切换（2026-10-13 新增）
     *
     * 背景：页脚备案号原本直接读接口返回的 web_icp（当前值「京ICP备2024083745号-1」）。
     * 但 yunyuanqu.cn 是**独立备案**的域名 —— 京ICP备2025139328号，
     * 与 yunyuanqu.com 那条不是同一个号。
     *
     * 为什么不改数据库：web_icp 存在**共用数据库**里，改它会让
     * yunyuanqu.com 前台和 APP 一起跟着变。所以这里只在前端按域名覆盖，
     * 数据库一字节不动，其他端完全不受影响。
     *
     * 判断用正则而非 includes，避免 `xyunyuanqu.cn` 这类前缀域名误命中。
     */
    isYunyuanquCn() {
      const host = (window.location.hostname || "").toLowerCase();
      return /(^|\.)yunyuanqu\.cn$/.test(host);
    },
    icpText() {
      if (this.isYunyuanquCn) return "京ICP备2025139328号";
      return this.SettingList.web_icp || "";
    },
    icpUrl() {
      if (this.isYunyuanquCn) return "https://beian.miit.gov.cn/";
      return this.SettingList.web_icp_url || "https://beian.miit.gov.cn/";
    },
  },
  mounted() {
    this.corporateSettingList();
    console.log(this.$route.path);
    let route = this.$route.path;
    this.tabs.forEach((item) => {
      item.in = false;
      let st = null;
      if (item.rou) {
        st = item.rou.findIndex((ite) => ite == route);
        if (st !== -1) {
          item.in = true;
        }
      } else {
        console.log(11);
      }
    });
  },
  methods: {
    
    tabsClick(item) {
      console.log(item);

      if (item.route) {
        this.$router.push(item.route);
      }
    },
    corporateSettingList() {
      if (sessionStorage.getItem("SettingList")) {
        let ct = JSON.parse(sessionStorage.getItem("SettingList"));
        this.SettingList = ct;
        return;
      }
      corporateSettingApi({}).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.SettingList = res.data;
          sessionStorage.setItem("SettingList", JSON.stringify(res.data));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link{
  font-size: 14px;
}
.boxxxx{
  margin-left: 10px;
  font-size: 14px;
}
.box-text {
  width: 100%;
  margin: 0 auto;
  height: 12px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 12px;
  color: #000;
  line-height: 12px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  text-decoration: none;
}
.BottomNavigation {
  width: 100%;
  height: 10vh;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  .BottomNavigation-tabs {
    width: 100%;
    height: 48px;
    box-sizing: border-box;
    display: flex;
    /* margin-left: 1492px; */
    justify-content: flex-end;
    /* 四格等宽后靠 gap 控制间距，不再靠每格右边的 margin 撑开。
       原来最右一格是靠 .box 的 margin-right: 52px 留出边距的，
       改等宽后 margin 归零，这个右边距得挪到容器上，否则会贴屏幕边。 */
    gap: 8px;
    padding-right: 52px;
    margin-top: 10px;
  }
  .box {
    display: flex;
    flex-direction: column;
    /* 关键：四格等宽。「首页」是 2 个字、其余是 4 个字，
       只按内容撑宽会让四个格子宽窄不一、下划线也长短不齐。
       给一个统一下限，四格就一样宽了。 */
    min-width: 104px;
    align-items: center;
    margin-right: 0;
    cursor: pointer;

    .box-item {
      height: 16px;
      width: 100%;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 16px;
      /* 原为 left：等宽之后左对齐会看着偏，改居中 */
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin-bottom: 6px;
    }
    .box-item1 {
      /* 原为 100%：等宽后会拉成一条长横线，改成居中的短下划线 */
      width: 40px;
      height: 4px;
      border-radius: 2px;
      background: linear-gradient(90deg, #4834d4 0%, rgba(72, 52, 212, 0) 100%);
    }
  }
}

/* ============================================================
   variant="pill"：浅色收口条 + 胶囊按钮
   个人中心及其二级页统一用这套外观，和页面内容卡（1280px）严格对齐。
   写法说明：所有规则都带上 .is-pill，比上面的基础规则多一层类名，
   同文件内靠特异性取胜、不依赖加载顺序，也不需要 !important。
   ============================================================ */
.BottomNavigation.is-pill {
  box-sizing: border-box;
  /* DOM 顺序是「tabs 在前、备案在后」，反转成「左备案 / 右按钮」的一行页脚 */
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  /* 与内容卡片左右对齐。必须写 calc((100% - 1280px)/2)：
     本项目 px 会被 postcss 按 rem 换算（rootValue≈19.2），
     用同一套表达式才能自动跟随换算，写死 vw / margin 都会差出几十像素。 */
  padding: 0 calc((100% - 1280px) / 2);
  background: linear-gradient(180deg, #fbfbfe 0%, #f1f2f9 100%);
  border-top: 1px solid #e6e9f2;
  box-shadow: 0 -10px 34px rgba(31, 34, 51, 0.06);

  .BottomNavigation-tabs {
    width: auto;
    height: auto;
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
  }

  .box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 0;
    /* 与默认分支同理：四格等宽，否则「首页」这枚胶囊比另外三个窄一截。
       border-box 让 min-width 把 padding 一起算进去，宽度才可控。 */
    box-sizing: border-box;
    min-width: 112px;
    padding: 9px 16px;
    border-radius: 999px;
    background: transparent;
    transition: background 0.25s ease, box-shadow 0.25s ease;

    .box-item {
      height: auto;
      margin-bottom: 0;
      font-size: 15px;
      font-weight: 600;
      line-height: 1;
      color: #6b7185;
      text-align: center;
      transition: color 0.25s ease;
    }

    /* 原下划线：改成当前项胶囊内的小白条 */
    .box-item1 {
      position: absolute;
      left: 50%;
      bottom: 4px;
      width: 18px;
      height: 3px;
      margin-left: -9px;
      border-radius: 3px;
      background: rgba(255, 255, 255, 0.92);
    }

    &:hover {
      background: rgba(72, 52, 212, 0.08);
      .box-item {
        color: #4834d4;
      }
    }

    /* 当前页高亮：这里用 item.in 算出的 .is-active，
       不能用 CSS :has(.box-item1) —— v-show 隐藏的元素仍留在 DOM 里，
       :has() 会把四个按钮全部点亮。 */
    &.is-active {
      background: linear-gradient(135deg, #4834d4 0%, #6c5ce7 100%);
      box-shadow: 0 8px 20px rgba(72, 52, 212, 0.3);

      .box-item {
        color: #ffffff;
      }

      &:hover {
        background: linear-gradient(135deg, #4834d4 0%, #6c5ce7 100%);
        .box-item {
          color: #ffffff;
        }
      }
    }
  }

  .box-text {
    width: auto;
    height: auto;
    /* 原组件是 margin:0 auto，那个 auto 在 flex 容器里会变成自动外边距，
       把备案信息推向中间，导致与内容卡片对不齐（实测差 102px）。必须归零。 */
    margin: 0;
    font-size: 13px;
    line-height: 1.4;
    color: #9aa0b4;
    letter-spacing: 0.2px;
    text-align: left;

    .link {
      font-size: 13px;
      color: #9aa0b4;
      transition: color 0.2s ease;

      &:hover {
        color: #4834d4;
      }
    }

    .boxxxx {
      position: relative;
      margin-left: 22px;
      font-size: 13px;
      color: #9aa0b4;
    }

    /* 只在后一项前加分隔圆点，避免行首多一个孤零零的符号 */
    .boxxxx + .boxxxx::before {
      content: "";
      position: absolute;
      left: -12px;
      top: 50%;
      width: 3px;
      height: 3px;
      margin-top: -1.5px;
      border-radius: 50%;
      background: #d8dce6;
    }
  }
}
</style>